/**
 * A super module that collects available sub-modules.
 * 
 * @namespace vef.ui
 * @memberof vef
 */

import * as color from './color/index.js';
export { color };

import * as dnd from './dnd/index.js';
export { dnd };

import * as sidebar from './sidebar/index.js';
export { sidebar };

import * as slider from './slider/index.js';
export { slider };

import * as table from './table/index.js';
export { table };

import * as media from './media/index.js';
export { media };

export * from './CheckboxGroup.js';
export * from './Dropdown.js';
export * from './ContextMenu.js';
export * from './TabGroup.js';
export * from './Tree.js';
export * from './Window.js';
export * from './UiElement.js';
export * from './FeedbackWidget.js';
export * from './PopupTour.js';